import { combineEpics, ofType } from 'redux-observable';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import * as actionTypes from './actionTypes';
import api from '../../api';
import { fetchNewsSuccess, fetchNewsError } from './actions';


const fetch = (action$) => action$.pipe(
  ofType(actionTypes.FETCH),
  switchMap(() => api.news.fetch().pipe(
    mergeMap((response) => {
      const news = response.body;
      return [
        fetchNewsSuccess(news),
      ];
    }),
    catchError((error) => [fetchNewsError(error)]),
  )),
);


export default combineEpics(fetch);
